<div class="box box--search">
    <div class="row">
        <div class="col-6 col-lg-12">
            <div class="headline-wrap">
                <div class="headline">
                    <h3 class="headline__title">WYSZUKAJ</h3>
                </div>
            </div>
        </div>
<!--        <div class="col-6 d-lg-none">-->
<!--            <h3 class="filter-count">118 OFERT</h3>-->
<!--        </div>-->
    </div>
    <div class="search-box">
      <ng-container *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'">
        <div class="search-box__field">
          <app-model-version-select-with-color
            [name]="'modelVersion'"
            [model]="getParamValue('models')"
            [version]="getParamValue('version')"
            [availableValues]="baseSearchFilters.model"
            [nullValue]="'Wybierz Model'"
            [icon]="'icon-model'"
            [sendStats]="true"
            [brandSlug]="brandSlug"
            (update)="update($event)"
            *ngIf="baseSearchFilters.model !== undefined"
          ></app-model-version-select-with-color>
        </div>

        <div class="search-box__field" *ngIf="advancedFilters.maxLength !== undefined">
          <app-model-length-select
            [class]="'model-length-select'"
            [name]="'maxLength'"
            [value]="getParamValue('maxLength')"
            [version]="getParamValue('version')"
            [availableValues]="advancedFilters.maxLength"
            [nullValue]="'Wybierz długość'"
            [icon]="null"
            (update)="update($event)"
            (maxLength)="changedLength($event)"
            (maxHeight)="changedHeight($event)"
          ></app-model-length-select>
        </div>

        <div class="search-box__field" *ngIf="advancedFilters.maxLength !== undefined && maxLength !== null && availableValuesMaxHeight !== null">
          <app-model-height-select
            [class]="'model-height-select'"
            [name]="'maxHeight'"
            [value]="getParamValue('maxHeight')"
            [availableValues]="availableValuesMaxHeight"
            [maxLength]="maxLength"
            [nullValue]="'Wybierz wysokość'"
            [icon]="null"
            (update)="update($event)"
          ></app-model-height-select>
        </div>

        <div class="search-box__field">
          <app-select-checkbox-list
            [name]="'fuelType'"
            [class]="'stock-select--checkbox-list'"
            [value]="getParamValue('fuelType')"
            [availableValues]="baseSearchFilters.fuelType"
            [nullValue]="'Rodzaj paliwa'"
            [icon]="'icon-fuel'"
            (update)="update($event)"
          ></app-select-checkbox-list>
        </div>

        <div class="search-box__field">
          <app-select-checkbox-list
            [name]="'gearboxType'"
            [class]="'stock-select--checkbox-list'"
            [value]="getParamValue('gearboxType')"
            [availableValues]="advancedFilters.gearboxType"
            [nullValue]="'Rodzaj skrzyni biegów'"
            [icon]="'icon-fuel'"
            (update)="update($event)"
          ></app-select-checkbox-list>
        </div>

        <div class="search-box__field">
          <app-select-checkbox-list
            [name]="'production_year'"
            [class]="'stock-select--checkbox-list'"
            [value]="getParamValue('production_year')"
            [availableValues]="advancedFilters.productionYear"
            [nullValue]="'Rok produkcji'"
            [icon]="'icon-calendar'"
            (update)="update($event)"
          ></app-select-checkbox-list>
        </div>

        <div class="search-box__field">
          <app-mileage-select
            [name]="'mileage'"
            [class]="'stock-select--box-mileage'"
            [value]="getParamValue('mileage')"
            [availableValues]="baseSearchFilters.mileageRanges"
            [nullValue]="'Przebieg'"
            [icon]="'icon-meter'"
            (update)="update($event)"
          ></app-mileage-select>
        </div>

        <div class="search-box__field">
          <app-price-field
            [name]="'price_from_to'"
            [valueFrom]="getParamValue('price_from')"
            [valueTo]="getParamValue('price_to')"
            [priceFrom]="baseSearchFilters.priceFrom"
            [priceTo]="baseSearchFilters.priceTo"
            [nullValueFrom]="'od'"
            [nullValueTo]="'do'"
            [icon]="'icon-price'"
            (update)="update($event)"
          ></app-price-field>
        </div>

<!--        <div class="search-box__field search-box__field&#45;&#45;full-width">-->
<!--          <app-location-select style="width: 100%;"-->
<!--                               (update)="update($event)"-->
<!--                               [value]="getParamValue('place_id')"-->
<!--                               [maxDistance]="getParamValue('max_distance')"-->
<!--          ></app-location-select>-->
<!--        </div>-->
      </ng-container>

      <ng-container *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'">
        <div class="search-box__field">
          <app-model-version-select
            [name]="'modelVersion'"
            [model]="getParamValue('models')"
            [version]="getParamValue('version')"
            [availableValues]="baseSearchFilters.model"
            [nullValue]="'Wybierz Model'"
            [icon]="'icon-model'"
            [sendStats]="true"
            (update)="update($event)"
            *ngIf="baseSearchFilters.model !== undefined"
          ></app-model-version-select>
        </div>

        <div class="search-box__field">
          <app-multiple-select
            [name]="'fuelType'"
            [value]="getParamValue('fuelType')"
            [availableValues]="baseSearchFilters.fuelType"
            [nullValue]="'Rodzaj paliwa'"
            [icon]="'icon-fuel'"
            (update)="update($event)"
          ></app-multiple-select>
        </div>
        <div class="search-box__field">
          <app-price-select
            [name]="'price_from'"
            [value]="getParamValue('price_from')"
            [availableValues]="baseSearchFilters.priceFrom"
            [nullValue]="'Cena od'"
            [icon]="'icon-price'"
            (update)="update($event)"
          ></app-price-select>
        </div>
        <div class="search-box__field">
          <app-price-select
            [name]="'price_to'"
            [value]="getParamValue('price_to')"
            [availableValues]="baseSearchFilters.priceTo"
            [nullValue]="'Cena do'"
            [icon]="'icon-price'"
            (update)="update($event)"
          ></app-price-select>
        </div>

        <div class="search-box__field">
          <app-multiple-select
            [name]="'production_year'"
            [value]="getParamValue('production_year')"
            [availableValues]="advancedFilters.productionYear"
            [nullValue]="'Rok produkcji'"
            [icon]="'icon-calendar'"
            (update)="update($event)"
          ></app-multiple-select>
        </div>

        <div class="search-box__field">
          <app-mileage-select
            [name]="'mileage'"
            [value]="getParamValue('mileage')"
            [availableValues]="baseSearchFilters.mileageRanges"
            [nullValue]="'Przebieg'"
            [icon]="'icon-meter'"
            (update)="update($event)"
          ></app-mileage-select>
        </div>

<!--        <div class="search-box__field search-box__field&#45;&#45;full-width">-->
<!--          <app-location-select style="width: 100%;"-->
<!--                               (update)="update($event)"-->
<!--                               [value]="getParamValue('place_id')"-->
<!--                               [maxDistance]="getParamValue('max_distance')"-->
<!--          ></app-location-select>-->
<!--        </div>-->

<!--        <div *ngIf="newCarsOfferCount !== null && newCarsOfferCount > 0 && initOfferCount != 0" class="d-none d-lg-block list-top-link">-->
<!--          <a [href]="newCarsUrl">Sprawdź dostępne samochody nowe<i class="icon icon-right_arrow"></i></a>-->
<!--        </div>-->
      </ng-container>

      <div class="search-box__field search-box__field--full-width">
        <app-location-select style="width: 100%;"
                             (update)="update($event)"
                             [value]="getParamValue('place_id')"
                             [maxDistance]="getParamValue('max_distance')"
                             [brandSlug]="brandSlug"
        ></app-location-select>
      </div>


<!--      <div *ngIf="brandSlug === 'fiat' && newCarsOfferCount !== null && newCarsOfferCount > 0 && initOfferCount != 0" class="list-top-link">-->
      <div *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'" class="list-top-link">
        <a [href]="newCarsUrl">
          <span>Sprawdź dostępne samochody nowe</span>
          <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1489 0.189729L19.8085 8.04195C19.869 8.10103 19.9172 8.17209 19.9501 8.25083C19.983 8.32957 20 8.41434 20 8.5C20 8.58566 19.983 8.67043 19.9501 8.74917C19.9172 8.82791 19.869 8.89897 19.8085 8.95805L12.1489 16.8103C12.0304 16.9318 11.8697 17 11.7021 17C11.5345 17 11.3738 16.9318 11.2553 16.8103C11.1368 16.6888 11.0702 16.524 11.0702 16.3522C11.0702 16.1804 11.1368 16.0157 11.2553 15.8942L17.8191 9.15435L0.638298 9.15435C0.46901 9.15435 0.306657 9.08541 0.186953 8.9627C0.0672486 8.83998 -3.63961e-07 8.67354 -3.71547e-07 8.5C-3.79133e-07 8.32646 0.0672486 8.16002 0.186953 8.0373C0.306657 7.91459 0.46901 7.84565 0.638298 7.84565L17.8191 7.84565L11.2553 1.10582C11.1368 0.98434 11.0702 0.819576 11.0702 0.647775C11.0702 0.475975 11.1368 0.31121 11.2553 0.189729C11.3738 0.0682483 11.5345 -5.04191e-07 11.7021 -5.11516e-07C11.8697 -5.18842e-07 12.0304 0.0682482 12.1489 0.189729Z" fill="#FEFFFF"/>
          </svg>
        </a>
      </div>

      <div *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional' && newCarsOfferCount !== null && newCarsOfferCount > 0 && initOfferCount != 0" class="d-none d-lg-block list-top-link">
        <a [href]="newCarsUrl">Sprawdź dostępne samochody nowe<i class="icon icon-right_arrow"></i></a>
      </div>

    </div>
</div>

<div class="box" *ngIf="false">
    <div class="headline-wrap">
        <div class="headline">
            <h3 class="headline__title headline__title--icon headline__title--click headline__title--filters" (click)="onChangeToggleAdvancedFilter()">
                <i class="icon icon-right_arrow {{ toggleAdvancedFilter ? 'icon-up' : 'icon-down' }}"></i>
                {{ toggleAdvancedFilter ? 'UKRYJ' : 'POKAŻ' }} WIĘCEJ FILTRÓW
            </h3>
            <span class="headline__btn" *ngIf="isSelectedAdvancedSearchFilters()" (click)="clearFilters()">
                usuń wszystko
            </span>
        </div>
    </div>
    <div class="filters-wrap" *ngIf="toggleAdvancedFilter">
        <app-filter-box [title]="'Rok produkcji'" [col]="'left'">
            <app-multiple-select
                    [class]="'multiple-select'"
                    [name]="'production_year'"
                    [value]="getParamValue('production_year')"
                    [availableValues]="advancedFilters.productionYear"
                    [nullValue]="'Wybierz rok produkcji'"
                    (update)="update($event)"
            ></app-multiple-select>
        </app-filter-box>

        <app-filter-box [title]="'Rodzaj skrzyni biegów'" [col]="'right'">
            <app-checkbox
                    [name]="'gearboxType'"
                    [value]="getParamValue('gearboxType')"
                    [availableValues]="advancedFilters.gearboxType"
                    (update)="update($event)"
            ></app-checkbox>
        </app-filter-box>

        <app-filter-box [title]="'Rodzaj napędu'" [col]="'left'">
            <app-checkbox
                    [name]="'driveType'"
                    [value]="getParamValue('driveType')"
                    [availableValues]="advancedFilters.driveType"
                    (update)="update($event)"
            ></app-checkbox>
        </app-filter-box>

        <app-filter-box [title]="'Moc silnika'" [col]="'right'" [appendClass]="'filter-box--engine-power'">
            <app-select
                    [name]="'enginePower_from'"
                    [value]="getParamValue('enginePower_from')"
                    [nullValue]="'MOC SILNIKA OD'"
                    [availableValues]="advancedFilters.enginePowerFrom"
                    (update)="update($event)"
            ></app-select>
            <app-select
                    [name]="'enginePower_to'"
                    [value]="getParamValue('enginePower_to')"
                    [nullValue]="'MOC SILNIKA DO'"
                    [availableValues]="advancedFilters.enginePowerTo"
                    (update)="update($event)"
            ></app-select>
        </app-filter-box>

        <app-filter-box [title]="'Kolor Lakieru'" [col]="'left'">
            <app-color-select
                    [name]="'color'"
                    [value]="getParamValue('color')"
                    [availableValues]="advancedFilters.color"
                    (update)="update($event)"
            ></app-color-select>
        </app-filter-box>

        <app-filter-box [title]="'Rodzaj tapicerki'" [col]="'right'">
            <app-checkbox
                    [name]="'interior_type'"
                    [value]="getParamValue('interior_type')"
                    [availableValues]="advancedFilters.interiorType"
                    (update)="update($event)"
            ></app-checkbox>
        </app-filter-box>

        <app-filter-box [title]="'Wyposażenie'" [col]="'full-width'">
            <app-equipment-select
                    [class]="'equipment-select'"
                    [name]="'equipment'"
                    [value]="getParamValue('equipment')"
                    [availableValues]="advancedFilters.equipment"
                    [nullValue]="'Wybierz wyposażenie'"
                    (update)="update($event)"
            ></app-equipment-select>
        </app-filter-box>
    </div>
</div>

<app-recommended
    [data]="baseSearchFilters.recommended"
    (update)="update($event)"
    *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional' && baseSearchFilters.recommended && baseSearchFilters.recommended.length > 0">
</app-recommended>


<app-popular
    [data]="baseSearchFilters.popular"
    (update)="update($event)"
    *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional' && baseSearchFilters.popular && baseSearchFilters.popular.length > 0">
</app-popular>

<div class="box box--footer text-center" *ngIf="brandSlug !== 'fiat' && brandSlug !== 'fiat-professional'">
  <button class="btn text-uppercase" (click)="clearFiltersAll()">Wyczyść filtry</button>
</div>

<div class="box box--footer text-center" *ngIf="brandSlug === 'fiat' || brandSlug === 'fiat-professional'">
  <button class="btn btn-clear" (click)="clearFiltersAll()">Wyczyść</button>
  <button class="btn btn-result" (click)="closeSearchBox()">Wyniki</button>
</div>
